<script>
export default {
  name: "AppMenu"
}
</script>
<template>
  <div class="menu"></div>
</template>
<style lang="scss">

</style>